import React from 'react';
import Icon from '../../../components/AppIcon';

const InspectionProgressBar = ({ categories, inspectionData }) => {
  const totalCategories = categories?.length;
  const completedCategories = categories?.filter(cat => {
    const data = inspectionData?.[cat?.key];
    return data?.status && data?.findings && data?.recommendations && data?.photos?.length > 0;
  })?.length;

  const progressPercentage = totalCategories > 0 ? Math.round((completedCategories / totalCategories) * 100) : 0;

  const getProgressColor = () => {
    if (progressPercentage === 100) return 'bg-success';
    if (progressPercentage >= 50) return 'bg-warning';
    return 'bg-primary';
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-lg bg-primary/10">
            <Icon name="ClipboardCheck" size={24} className="text-primary" />
          </div>
          <div>
            <h3 className="text-base md:text-lg font-heading font-semibold text-foreground">
              Progreso de Inspección
            </h3>
            <p className="text-xs md:text-sm caption text-muted-foreground">
              {completedCategories} de {totalCategories} categorías completadas
            </p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-2xl md:text-3xl font-heading font-bold text-foreground">
            {progressPercentage}%
          </p>
        </div>
      </div>
      <div className="w-full bg-muted rounded-full h-3 md:h-4 overflow-hidden">
        <div
          className={`h-full ${getProgressColor()} transition-all duration-500 ease-out`}
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4 mt-4 md:mt-6">
        {categories?.map((cat) => {
          const data = inspectionData?.[cat?.key];
          const isComplete = data?.status && data?.findings && data?.recommendations && data?.photos?.length > 0;
          
          return (
            <div
              key={cat?.key}
              className={`flex items-center gap-2 p-2 md:p-3 rounded-lg border transition-smooth ${
                isComplete
                  ? 'bg-success/10 border-success/20' :'bg-muted/50 border-border'
              }`}
            >
              <Icon
                name={isComplete ? 'CheckCircle2' : 'Circle'}
                size={16}
                className={isComplete ? 'text-success' : 'text-muted-foreground'}
              />
              <span className="text-xs md:text-sm font-body text-foreground truncate">
                {cat?.title}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InspectionProgressBar;